export enum PerformanceResources {
    Duplicate = '/v2/performanceManagement/templates/:template/duplicate',
    ReviewCreation = '/v2/performanceManagement/reviews/createBulkReviews',
}
